import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IExpenseType, ExpenseType} from 'app/blocks/model/expense-type.model';
import {Resource} from 'app/constants/resource';

import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class ExpenseTypeService extends EntityCrudService<IExpenseType> {
    constructor(http: HttpClient) {
        super(http, Resource.EXPENSE_TYPES, (obj?) => new ExpenseType(obj));
    }
}
